import { AssessmentStatus } from '@/enums'
import { evolve, pipe, omit, pick, propEq } from 'ramda'

export const makeInitialValues = evolve({
  address: pipe(omit(['addressId'])),
})

export const transform = pipe(
  pick(['address', 'name', 'selfAssessment', 'riskChecklist']),
)

export const checkCompletedAssessment = pipe(
  propEq(AssessmentStatus.completed, 'selfAssessment'),
)

export const checkPoaSigned = pipe(
  (data) =>
    data.riskChecklist.checks.find(
      (check: { type: string; isDone: boolean }) => check.type === 'signedPOA',
    )?.isDone,
)
